import React, { useEffect, useState } from "react";


const Daterangefilter = ({ setFilters, filter }) => {
    const [min, setMin] = useState(filter.value?.min ?? undefined);
    const [max, setMax] = useState(filter.value?.max ?? undefined);
    const [currentMin, setCurrentMin] = useState(null);
    const [currentMax, setCurrentMax] = useState(null);

    const setFilterValue = () => {
        setFilters((filters) => {
            const newFilters = [...filters];
            newFilters[filters.findIndex((e) => e.index == filter.index)].value = { min: min, max: max }
            return newFilters
        })
    }
    useEffect(() => {
        setFilterValue();
    }, [min, max])

    const setMinValue = (value) => {
        setMin(value);
        setCurrentMin(null);
    }
    const setMaxValue = (value) => {
        setMax(value);
        setCurrentMax(null);
    }
    return <div className="d-flex w-100 h-100">
        <div className="bg-white rounded-4 p-4 border border-gray w-100">
            <h6 className="fw-bold">{filter.name}</h6>
            <div className="d-flex flex-column  align-items-center">
                <input type="date" value={currentMin !== null ? currentMin : filter.value?.min ?? ''} onChange={(e) => setCurrentMin(e.target.value)} onBlur={(e) => setMinValue(e.target.value)} className="standardInput dateIcon w-100 placeholderStyle" />
                <span className="px-2"> - </span>
                <input type="date" value={currentMax !== null ? currentMax : filter.value?.max ?? ''} onChange={(e) => setCurrentMax(e.target.value)} onBlur={(e) => setMaxValue(e.target.value)} className="standardInput dateIcon w-100 placeholderStyle" />
            </div>
        </div>
    </div>
}

export default Daterangefilter;